if (!customElements.get('ss-footer-newsletter')) {
  customElements.define('ss-footer-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      // Focus sur le message de retour après rechargement
      const message = this.querySelector('[data-ss-message]');
      if (message && window.location.search.includes('form_type=customer')) {
        requestAnimationFrame(() => {
          message.focus({ preventScroll: true });
          SS.scrollTo(this, 80);
        });
      }

      // Empêche le double envoi
      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    onSubmit() {
      const btn = this.form.querySelector('button[type="submit"]');
      if (!btn) return;
      // Après validation native uniquement
      requestAnimationFrame(() => { btn.disabled = true; });
    }
  });
}